import React, {useEffect} from "react";
import {Document, Page, pdfjs} from "react-pdf";

import styles from "./IsaacPdfViewer.module.scss";
import IsaacPdfHeader from "../isaacPdfHeader/IsaacPdfHeader";

const IsaacPdfViewer: React.FunctionComponent<{
  url: string;
  constructionNo: string;
}> = ({url, constructionNo}) => {
  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

    return () => {
      pdfjs.GlobalWorkerOptions.workerSrc = "";
    };
  }, []);

  return (
    <Document renderMode="canvas" file={url}>
      {Array.from(Array(3).keys()).map((i, index) => (
        <div key={index} className={styles.pageContainer}>
          <IsaacPdfHeader headerNo={constructionNo} />
          <Page
            scale={1}
            key={index}
            pageNumber={i + 1}
            renderAnnotationLayer={false}
            renderTextLayer={false}
            height={1800}
          />
        </div>
      ))}
    </Document>
  );
};

export default IsaacPdfViewer;
